class NewsletterPopup extends ModalDialog {
  constructor() {
    super();
    this.init();
    this.attachEventListeners();
  }

  // Moved all event listeners to a separate method for better organization
  attachEventListeners() {
    this.buttonClose = this.querySelector(".js-button-close");
    // if (this.buttonClose) {
    //   this.buttonClose.addEventListener("click", this.closeNewsletter.bind(this));
    // }

    this.querySelectorAll(".js-button-close").forEach(button => {
      button.addEventListener("click", this.closeNewsletter.bind(this));
    });

    if (this.form) {
      this.form.addEventListener("submit", this.onSubscribe.bind(this));
    }
  }

  init() {
    this.delay = this.dataset.delay * 1000;
    this.closed = getCookie("newsletter-closed");
    this.subscribed = getCookie("newsletter-subscribed");
    this.form = this.querySelector(".js-form");
    this.ageVerificationPopup = document.querySelector("age-verification-popup");
  }

  closeNewsletter() {
    setCookie("newsletter-closed", "true");
    this.hide();
  }

  // connectedCallback() {
  //   if (Shopify.designMode) {
  //     if (this.dataset.openInDesignMode === "true") {
  //     this.show();
  //     }
  //     return;
  //   }

  //   this.handlePopupVisibility();
  // }

  connectedCallback() {
    if (Shopify.designMode) {
      if (this.dataset.openInDesignMode === "true") {
        this.show();
      }
      return;
    }

    if (this.handleReturnFromSubmit()) return;

    this.handlePopupVisibility();
  }

  handlePopupVisibility() {
    if (getCookie("age-verified") !== "true" && this.ageVerificationPopup) {
      this.handleAgeVerificationPopup();
    } else {
      this.showPopupWithDelay();
    }
  }

  handleAgeVerificationPopup() {
    let prevClassState = this.classList.contains("newsletter-popup-is-hidden");

    const observer = new MutationObserver(mutations => {
      const mutation = mutations[0];
      if (mutation.attributeName !== "class") return;

      const currentClassState = mutation.target.classList.contains("newsletter-popup-is-hidden");

      if (prevClassState !== currentClassState) {
        prevClassState = currentClassState;
        if (!currentClassState) {
          this.showPopupWithDelay();
        }
      }
    });

    observer.observe(this, { attributes: true });
  }

  showPopupWithDelay() {
    setTimeout(() => {
      if (this.closed !== "true" && this.subscribed !== "true") {
        this.show();
      }
    }, this.delay);
  }

  onSubscribe() {
    setCookie("newsletter-subscribed", "true");
    this.hide();
  }

  handleReturnFromSubmit() {
    const params = new URLSearchParams(window.location.search);
    if (params.get("customer_posted") !== "true") return false;
    if (!this.form || window.location.hash !== `#${this.form.id}`) return false;

    setCookie("newsletter-subscribed", "true");
    this.showMessage("success");
    this.show();
    return true;
  }

  showMessage(state) {
    const content = this.querySelector(".newsletter-popup__content");
    if (!content) return;

    content.dataset.state = state;

    const message = this.querySelector(`[data-newsletter-message="${state}"]`);
    if (message) message.hidden = false;
  }

}

customElements.define("newsletter-popup", NewsletterPopup);
